/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shareneedspublish2Inputs */

const en_shareneedspublish2 = /** @type {(inputs: Shareneedspublish2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share – publish first`)
};

const de_shareneedspublish2 = /** @type {(inputs: Shareneedspublish2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen – zuerst veröffentlichen`)
};

/**
* | output |
* | --- |
* | "Share – publish first" |
*
* @param {Shareneedspublish2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const shareneedspublish2 = /** @type {((inputs?: Shareneedspublish2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shareneedspublish2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shareneedspublish2(inputs)
	return de_shareneedspublish2(inputs)
});
export { shareneedspublish2 as "shareNeedsPublish" }